const {
  react_app_api_base_url,
  react_app_auth_host,
  react_app_cognito,
  react_app_default_login,
  react_app_encryption_public_key,
  react_app_environment,
  react_app_image_host,
  react_app_version,
  react_app_saml
} = window.zino_env;

export const AUTH_HOST_URL = react_app_auth_host;
export const IMAGE_HOST_URL = react_app_image_host;
export const BASE_URL = react_app_api_base_url || "https://sandbox.getzino.site";
export const PUBLIC_ENCRYPTION_KEY = react_app_encryption_public_key;
export const APP_VERSION = react_app_version;
export const APP_ENVIRONMENT = react_app_environment;
export const APP_DEFAULT_LOGIN = react_app_default_login;
export const APP_COGNITO = react_app_cognito;
export const ENABLE_SAML_LOGIN = react_app_saml;
